import { render, staticRenderFns } from "./UserTerms.vue?vue&type=template&id=6f15235c&scoped=true&"
import script from "./UserTerms.vue?vue&type=script&lang=js&"
export * from "./UserTerms.vue?vue&type=script&lang=js&"
import style0 from "./UserTerms.vue?vue&type=style&index=0&id=6f15235c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f15235c",
  null
  
)

export default component.exports